export default {
	addi_deftmel: {
		name: 'Addi Deftmel',
		bp: 10,
		mel_pot: 2.5,
		pot_floor: 2.5,
	},
	addi_deftmelra: {
		name: 'Addi Deftmelra',
		bp: '?',
		mel_pot: 2.5,
		rng_pot: 2.5,
		pot_floor: 2.5,
	},
	addi_deftmeltech: {
		name: 'Addi Deftmeltech',
		bp: '?',
		mel_pot: 2.5,
		tec_pot: 2.5,
		pot_floor: 2.5,
	},
	addi_deftmel_s: {
		name: 'Addi Deftmel S',
		bp: 10,
		mel_pot: 2.5,
		pot_floor: 2.5,
	},
	addi_deftmelra_s: {
		name: 'Addi Deftmelra S',
		bp: '?',
		mel_pot: 2.5,
		rng_pot: 2.5,
		pot_floor: 2.5,
	},
	addi_deftmeltech_s: {
		name: 'Addi Deftmeltech S',
		bp: '?',
		mel_pot: 2.5,
		tec_pot: 2.5,
		pot_floor: 2.5,
	},
	addi_deftra: {
		name: 'Addi Deftra',
		bp: 10,
		rng_pot: 2.5,
		pot_floor: 2.5,
	},
	addi_deftratech: {
		name: 'Addi Deftratech',
		bp: '?',
		rng_pot: 2.5,
		tec_pot: 2.5,
		pot_floor: 2.5,
	},
	addi_deftra_s: {
		name: 'Addi Deftra S',
		bp: 10,
		rng_pot: 2.5,
		pot_floor: 2.5,
	},
	addi_deftratech_s: {
		name: 'Addi Deftratech S',
		bp: '?',
		rng_pot: 2.5,
		tec_pot: 2.5,
		pot_floor: 2.5,
	},
	addi_defttech: {
		name: 'Addi Defttech',
		bp: 10,
		tec_pot: 2.5,
		pot_floor: 2.5,
	},
	addi_defttech_s: {
		name: 'Addi Defttech S',
		bp: 10,
		tec_pot: 2.5,
		pot_floor: 2.5,
	},
	addi_degolstamel: {
		name: 'Addi Degolstamel',
		bp: '?',
		hp: 20,
		mel_pot: 2.5,
		low_temp_resist: 25,
	},
	addi_degolstamel_s: {
		name: 'Addi Degolstamel S',
		bp: '?',
		hp: 20,
		mel_pot: 2.5,
		low_temp_resist: 25,
	},
	addi_degolstara: {
		name: 'Addi Degolstara',
		bp: '?',
		hp: 20,
		rng_pot: 2.5,
		low_temp_resist: 25,
	},
	addi_degolstara_s: {
		name: 'Addi Degolstara S',
		bp: '?',
		hp: 20,
		rng_pot: 2.5,
		low_temp_resist: 25,
	},
	addi_degolstatech: {
		name: 'Addi Degolstatech',
		bp: '?',
		hp: 20,
		tec_pot: 2.5,
		low_temp_resist: 25,
	},
	addi_degolstatech_s: {
		name: 'Addi Degolstatech S',
		bp: '?',
		hp: 20,
		tec_pot: 2.5,
		low_temp_resist: 25,
	},
	addi_degolstaspimel: {
		name: 'Addi Degolstaspimel',
		bp: '?',
		hp: 10,
		pp: 3,
		mel_pot: 2.5,
		low_temp_resist: 25,
	},
	addi_degolstaspimel_s: {
		name: 'Addi Degolstaspimel S',
		bp: '?',
		hp: 10,
		pp: 3,
		mel_pot: 2.5,
		low_temp_resist: 25,
	},
	addi_degolstaspira: {
		name: 'Addi Degolstaspira',
		bp: '?',
		hp: 10,
		pp: 3,
		rng_pot: 2.5,
		low_temp_resist: 25,
	},
	addi_degolstaspira_s: {
		name: 'Addi Degolstaspira S',
		bp: '?',
		hp: 10,
		pp: 3,
		rng_pot: 2.5,
		low_temp_resist: 25,
	},
	addi_degolstaspitech: {
		name: 'Addi Degolstaspitech',
		bp: '?',
		hp: 10,
		pp: 3,
		tec_pot: 2.5,
		low_temp_resist: 25,
	},
	addi_degolstaspitech_s: {
		name: 'Addi Degolstaspitech S',
		bp: '?',
		hp: 10,
		pp: 3,
		tec_pot: 2.5,
		low_temp_resist: 25,
	},
	addi_degolspimel: {
		name: 'Addi Degolspimel',
		bp: '?',
		pp: 6,
		mel_pot: 2.5,
		low_temp_resist: 25,
	},
	addi_degolspimel_s: {
		name: 'Addi Degolspimel S',
		bp: '?',
		pp: 6,
		mel_pot: 2.5,
		low_temp_resist: 25,
	},
	addi_degolspira: {
		name: 'Addi Degolspira',
		bp: '?',
		pp: 6,
		rng_pot: 2.5,
		low_temp_resist: 25,
	},
	addi_degolspira_s: {
		name: 'Addi Degolspira S',
		bp: '?',
		pp: 6,
		rng_pot: 2.5,
		low_temp_resist: 25,
	},
	addi_degolspitech: {
		name: 'Addi Degolspitech',
		bp: '?',
		pp: 6,
		tec_pot: 2.5,
		low_temp_resist: 25,
	},
	addi_degolspitech_s: {
		name: 'Addi Degolspitech S',
		bp: '?',
		pp: 6,
		tec_pot: 2.5,
		low_temp_resist: 25,
	},
	addi_degoldeftmel: {
		name: 'Addi Degoldeftmel',
		bp: '?',
		mel_pot: 2.5,
		pot_floor: 2.5,
		low_temp_resist: 25,
	},
	addi_degoldeftmel_s: {
		name: 'Addi Degoldeftmel S',
		bp: '?',
		mel_pot: 2.5,
		pot_floor: 2.5,
		low_temp_resist: 25,
	},
	addi_degoldeftra: {
		name: 'Addi Degoldeftra',
		bp: '?',
		rng_pot: 2.5,
		pot_floor: 2.5,
		low_temp_resist: 25,
	},
	addi_degoldeftra_s: {
		name: 'Addi Degoldeftra S',
		bp: '?',
		rng_pot: 2.5,
		pot_floor: 2.5,
		low_temp_resist: 25,
	},
	addi_degoldefttech: {
		name: 'Addi Degoldefttech',
		bp: '?',
		tec_pot: 2.5,
		pot_floor: 2.5,
		low_temp_resist: 25,
	},
	addi_degoldefttech_s: {
		name: 'Addi Degoldefttech S',
		bp: '?',
		tec_pot: 2.5,
		pot_floor: 2.5,
		low_temp_resist: 25,
	},
	addi_degolguamel: {
		name: 'Addi Degolguamel',
		bp: '?',
		mel_pot: 2.5,
		dmg_resist: 2.5,
		low_temp_resist: 25,
	},
	addi_degolguamel_s: {
		name: 'Addi Degolguamel S',
		bp: '?',
		mel_pot: 2.5,
		dmg_resist: 2.5,
		low_temp_resist: 25,
	},
	addi_degolguara: {
		name: 'Addi Degolguara',
		bp: '?',
		rng_pot: 2.5,
		dmg_resist: 2.5,
		low_temp_resist: 25,
	},
	addi_degolguara_s: {
		name: 'Addi Degolguara S',
		bp: '?',
		rng_pot: 2.5,
		dmg_resist: 2.5,
		low_temp_resist: 25,
	},
	addi_degolguatech: {
		name: 'Addi Degolguatech',
		bp: '?',
		tec_pot: 2.5,
		dmg_resist: 2.5,
		low_temp_resist: 25,
	},
	addi_degolguatech_s: {
		name: 'Addi Degolguatech S',
		bp: '?',
		tec_pot: 2.5,
		dmg_resist: 2.5,
		low_temp_resist: 25,
	},
	addi_degolwardmel: {
		name: 'Addi Degolwardmel',
		bp: '?',
		mel_pot: 2.5,
		all_resist: 20,
		low_temp_resist: 25,
	},
	addi_degolwardmel_s: {
		name: 'Addi Degolwardmel S',
		bp: '?',
		mel_pot: 2.5,
		all_resist: 20,
		low_temp_resist: 25,
	},
	addi_degolwardra: {
		name: 'Addi Degolwardra',
		bp: '?',
		rng_pot: 2.5,
		all_resist: 20,
		low_temp_resist: 25,
	},
	addi_degolwardra_s: {
		name: 'Addi Degolwardra S',
		bp: '?',
		rng_pot: 2.5,
		all_resist: 20,
		low_temp_resist: 25,
	},
	addi_degolwardtech: {
		name: 'Addi Degolwardtech',
		bp: '?',
		tec_pot: 2.5,
		all_resist: 20,
		low_temp_resist: 25,
	},
	addi_degolwardtech_s: {
		name: 'Addi Degolwardtech S',
		bp: '?',
		tec_pot: 2.5,
		all_resist: 20,
		low_temp_resist: 25,
	},
	addi_guamel: {
		name: 'Addi Guamel',
		bp: 10,
		mel_pot: 2.5,
		dmg_resist: 2.5,
	},
	addi_guamelra: {
		name: 'Addi Guamelra',
		bp: '?',
		mel_pot: 2.5,
		rng_pot: 2.5,
		dmg_resist: 2.5,
	},
	addi_guameltech: {
		name: 'Addi Guameltech',
		bp: '?',
		mel_pot: 2.5,
		tec_pot: 2.5,
		dmg_resist: 2.5,
	},
	addi_guamel_s: {
		name: 'Addi Guamel S',
		bp: 10,
		mel_pot: 2.5,
		dmg_resist: 2.5,
	},
	addi_guamelra_s: {
		name: 'Addi Guamelra S',
		bp: '?',
		mel_pot: 2.5,
		rng_pot: 2.5,
		dmg_resist: 2.5,
	},
	addi_guameltech_s: {
		name: 'Addi Guameltech S',
		bp: '?',
		mel_pot: 2.5,
		tec_pot: 2.5,
		dmg_resist: 2.5,
	},
	addi_guara: {
		name: 'Addi Guara',
		bp: 10,
		rng_pot: 2.5,
		dmg_resist: 2.5,
	},
	addi_guaratech: {
		name: 'Addi Guaratech',
		bp: '?',
		rng_pot: 2.5,
		tec_pot: 2.5,
		dmg_resist: 2.5,
	},
	addi_guara_s: {
		name: 'Addi Guara S',
		bp: 10,
		rng_pot: 2.5,
		dmg_resist: 2.5,
	},
	addi_guaratech_s: {
		name: 'Addi Guaratech S',
		bp: '?',
		rng_pot: 2.5,
		tec_pot: 2.5,
		dmg_resist: 2.5,
	},
	addi_guatech: {
		name: 'Addi Guatech',
		bp: 10,
		tec_pot: 2.5,
		dmg_resist: 2.5,
	},
	addi_guatech_s: {
		name: 'Addi Guatech S',
		bp: 10,
		tec_pot: 2.5,
		dmg_resist: 2.5,
	},
	addi_spimel: {
		name: 'Addi Spimel',
		bp: 10,
		pp: 6,
		mel_pot: 2.5,
	},
	addi_spimelra: {
		name: 'Addi Spimelra',
		bp: '?',
		pp: 6,
		mel_pot: 2.5,
		rng_pot: 2.5,
	},
	addi_spimeltech: {
		name: 'Addi Spimeltech',
		bp: '?',
		pp: 6,
		mel_pot: 2.5,
		tec_pot: 2.5,
	},
	addi_spimel_s: {
		name: 'Addi Spimel S',
		bp: 10,
		pp: 6,
		mel_pot: 2.5,
	},
	addi_spimelra_s: {
		name: 'Addi Spimelra S',
		bp: '?',
		pp: 6,
		mel_pot: 2.5,
		rng_pot: 2.5,
	},
	addi_spimeltech_s: {
		name: 'Addi Spimeltech S',
		bp: '?',
		pp: 6,
		mel_pot: 2.5,
		tec_pot: 2.5,
	},
	addi_spira: {
		name: 'Addi Spira',
		bp: 10,
		pp: 6,
		rng_pot: 2.5,
	},
	addi_spiratech: {
		name: 'Addi Spiratech',
		bp: '?',
		pp: 6,
		rng_pot: 2.5,
		tec_pot: 2.5,
	},
	addi_spira_s: {
		name: 'Addi Spira S',
		bp: 10,
		pp: 6,
		rng_pot: 2.5,
	},
	addi_spiratech_s: {
		name: 'Addi Spiratech S',
		bp: '?',
		pp: 6,
		rng_pot: 2.5,
		tec_pot: 2.5,
	},
	addi_spitech: {
		name: 'Addi Spitech',
		bp: 10,
		pp: 6,
		tec_pot: 2.5,
	},
	addi_spitech_s: {
		name: 'Addi Spitech S',
		bp: 10,
		pp: 6,
		tec_pot: 2.5,
	},
	addi_stamel: {
		name: 'Addi Stamel',
		bp: 10,
		hp: 20,
		mel_pot: 2.5,
	},
	addi_stamelra: {
		name: 'Addi Stamelra',
		bp: '?',
		hp: 20,
		mel_pot: 2.5,
		rng_pot: 2.5,
	},
	addi_stameltech: {
		name: 'Addi Stameltech',
		bp: '?',
		hp: 20,
		mel_pot: 2.5,
		tec_pot: 2.5,
	},
	addi_stamel_s: {
		name: 'Addi Stamel S',
		bp: 10,
		hp: 20,
		mel_pot: 2.5,
	},
	addi_stamelra_s: {
		name: 'Addi Stamelra S',
		bp: '?',
		hp: 20,
		mel_pot: 2.5,
		rng_pot: 2.5,
	},
	addi_stameltech_s: {
		name: 'Addi Stameltech S',
		bp: '?',
		hp: 20,
		mel_pot: 2.5,
		tec_pot: 2.5,
	},
	addi_stara: {
		name: 'Addi Stara',
		bp: 10,
		hp: 20,
		rng_pot: 2.5,
	},
	addi_staratech: {
		name: 'Addi Staratech',
		bp: '?',
		hp: 20,
		rng_pot: 2.5,
		tec_pot: 2.5,
	},
	addi_stara_s: {
		name: 'Addi Stara S',
		bp: 10,
		hp: 20,
		rng_pot: 2.5,
	},
	addi_staratech_s: {
		name: 'Addi Staratech S',
		bp: '?',
		hp: 20,
		rng_pot: 2.5,
		tec_pot: 2.5,
	},
	addi_statech: {
		name: 'Addi Statech',
		bp: 10,
		hp: 20,
		tec_pot: 2.5,
	},
	addi_statech_s: {
		name: 'Addi Statech S',
		bp: 10,
		hp: 20,
		tec_pot: 2.5,
	},
	addi_staspimel: {
		name: 'Addi Staspimel',
		bp: 10,
		hp: 10,
		pp: 3,
		mel_pot: 2.5,
	},
	addi_staspimelra: {
		name: 'Addi Staspimelra',
		bp: '?',
		hp: 10,
		pp: 3,
		mel_pot: 2.5,
		rng_pot: 2.5,
	},
	addi_staspimeltech: {
		name: 'Addi Staspimeltech',
		bp: '?',
		hp: 10,
		pp: 3,
		mel_pot: 2.5,
		tec_pot: 2.5,
	},
	addi_staspimel_s: {
		name: 'Addi Staspimel S',
		bp: 10,
		hp: 10,
		pp: 3,
		mel_pot: 2.5,
	},
	addi_staspimelra_s: {
		name: 'Addi Staspimelra S',
		bp: '?',
		hp: 10,
		pp: 3,
		mel_pot: 2.5,
		rng_pot: 2.5,
	},
	addi_staspimeltech_s: {
		name: 'Addi Staspimeltech S',
		bp: '?',
		hp: 10,
		pp: 3,
		mel_pot: 2.5,
		tec_pot: 2.5,
	},
	addi_staspira: {
		name: 'Addi Staspira',
		bp: 10,
		hp: 10,
		pp: 3,
		rng_pot: 2.5,
	},
	addi_staspiratech: {
		name: 'Addi Staspiratech',
		bp: '?',
		hp: 10,
		pp: 3,
		rng_pot: 2.5,
		tec_pot: 2.5,
	},
	addi_staspira_s: {
		name: 'Addi Staspira S',
		bp: 10,
		hp: 10,
		pp: 3,
		rng_pot: 2.5,
	},
	addi_staspiratech_s: {
		name: 'Addi Staspiratech S',
		bp: '?',
		hp: 10,
		pp: 3,
		rng_pot: 2.5,
		tec_pot: 2.5,
	},
	addi_staspitech: {
		name: 'Addi Staspitech',
		bp: 10,
		hp: 10,
		pp: 3,
		tec_pot: 2.5,
	},
	addi_staspitech_s: {
		name: 'Addi Staspitech S',
		bp: 10,
		hp: 10,
		pp: 3,
		tec_pot: 2.5,
	},
	addi_ward_i: {
		name: 'Addi Ward I',
		bp: 10,
		all_resist: 25,
	},
	addi_wardmel: {
		name: 'Addi Wardmel',
		bp: 10,
		mel_pot: 2.5,
		all_resist: 20,
	},
	addi_wardmelra: {
		name: 'Addi Wardmelra',
		bp: '?',
		mel_pot: 2.5,
		rng_pot: 2.5,
		all_resist: 20,
	},
	addi_wardmeltech: {
		name: 'Addi Wardmeltech',
		bp: '?',
		mel_pot: 2.5,
		tec_pot: 2.5,
		all_resist: 20,
	},
	addi_wardmel_s: {
		name: 'Addi Wardmel S',
		bp: 10,
		mel_pot: 2.5,
		all_resist: 20,
	},
	addi_wardmelra_s: {
		name: 'Addi Wardmelra S',
		bp: '?',
		mel_pot: 2.5,
		rng_pot: 2.5,
		all_resist: 20,
	},
	addi_wardmeltech_s: {
		name: 'Addi Wardmeltech S',
		bp: '?',
		mel_pot: 2.5,
		tec_pot: 2.5,
		all_resist: 20,
	},
	addi_wardra: {
		name: 'Addi Wardra',
		bp: 10,
		rng_pot: 2.5,
		all_resist: 20,
	},
	addi_wardratech: {
		name: 'Addi Wardratech',
		bp: '?',
		rng_pot: 2.5,
		tec_pot: 2.5,
		all_resist: 20,
	},
	addi_wardra_s: {
		name: 'Addi Wardra S',
		bp: 10,
		rng_pot: 2.5,
		all_resist: 20,
	},
	addi_wardratech_s: {
		name: 'Addi Wardratech S',
		bp: '?',
		rng_pot: 2.5,
		tec_pot: 2.5,
		all_resist: 20,
	},
	addi_wardtech: {
		name: 'Addi Wardtech',
		bp: 10,
		tec_pot: 2.5,
		all_resist: 20,
	},
	addi_wardtech_s: {
		name: 'Addi Wardtech S',
		bp: 10,
		tec_pot: 2.5,
		all_resist: 20,
	},
	ael_domina: {
		name: 'Ael Domina',
		bp: 8,
		hp: 5,
		pp: 3,
		mel_pot: 1.5,
		rng_pot: 1.5,
		tec_pot: 1.5,
	},
	ael_domina_ii: {
		name: 'Ael Domina II',
		bp: '?',
	},
	ael_note_a: {
		name: 'Ael Note A',
		bp: 5,
		hp: 5,
		pp: 3,
	},
	ael_note_b: {
		name: 'Ael Note B',
		bp: 4,
		mel_pot: 1,
		rng_pot: 1,
	},
	ael_note_c: {
		name: 'Ael Note C',
		bp: 4,
		mel_pot: 1,
		tec_pot: 1,
	},
	ael_note_d: {
		name: 'Ael Note D',
		bp: 4,
		rng_pot: 1,
		tec_pot: 1,
	},
	aglai_soul_h: {
		name: 'Aglai Soul H',
		bp: 11,
		hp: 15,
		mel_pot: 2.5,
		rng_pot: 2.5,
	},
	aglai_soul_p: {
		name: 'Aglai Soul P',
		bp: 11,
		pp: 5,
		mel_pot: 2.5,
		rng_pot: 2.5,
	},
	aglai_soul_x: {
		name: 'Aglai Soul X',
		bp: 11,
		hp: 10,
		pp: 3,
		mel_pot: 2.5,
		rng_pot: 2.5,
	},
	alno_note: {
		name: 'Alno Note',
		bp: 5,
		hp: 10,
		pp: 3,
		pot_floor: 2,
	},
	alts_secreta_i: {
		name: 'Alts Secreta I',
		bp: 3,
		hp: -10,
		mel_pot: 1,
		rng_pot: 1,
		tec_pot: 1,
		pot_floor: 1,
		dmg_resist: -1,
	},
	alts_secreta_i_s: {
		name: 'Alts Secreta I S',
		bp: 3,
		hp: -10,
		mel_pot: 1,
		rng_pot: 1,
		tec_pot: 1,
		pot_floor: 1,
		dmg_resist: -1,
	},
	alts_secreta_ii: {
		name: 'Alts Secreta II',
		bp: 4,
		hp: -10,
		mel_pot: 1.5,
		rng_pot: 1.5,
		tec_pot: 1.5,
		pot_floor: 1.5,
		dmg_resist: -1,
	},
	alts_secreta_iii: {
		name: 'Alts Secreta III',
		bp: 5,
		hp: -10,
		mel_pot: 2,
		rng_pot: 2,
		tec_pot: 2,
		pot_floor: 2,
		dmg_resist: -1.5,
	},
	alts_secreta_iv: {
		name: 'Alts Secreta IV',
		bp: '?',
		hp: -10,
		mel_pot: 2.5,
		rng_pot: 2.5,
		tec_pot: 2.5,
		pot_floor: 2.5,
		dmg_resist: -1.5,
	},
	alts_secreta_v: {
		name: 'Alts Secreta V',
		bp: '?',
		hp: -10,
		mel_pot: 2.75,
		rng_pot: 2.75,
		tec_pot: 2.75,
		pot_floor: 2.75,
		dmg_resist: -1.5,
	},
	alts_soul_i: {
		name: 'Alts Soul I',
		bp: 5,
		hp: 5,
		dmg_resist: 1,
	},
	alts_soul_ii: {
		name: 'Alts Soul II',
		bp: 7,
		hp: 10,
		dmg_resist: 2,
	},
	alts_soul_ii_s: {
		name: 'Alts Soul II S',
		bp: 7,
		hp: 10,
		dmg_resist: 2,
	},
	alts_soul_iii: {
		name: 'Alts Soul III',
		bp: 9,
		hp: 15,
		dmg_resist: 2.5,
	},
	alts_soul_iii_s: {
		name: 'Alts Soul III S',
		bp: 9,
		hp: 15,
		dmg_resist: 2.5,
	},
	alts_soul_iv: {
		name: 'Alts Soul IV',
		bp: '?',
		hp: 15,
		dmg_resist: 2.5,
	},
	alts_soul_v: {
		name: 'Alts Soul V',
		bp: '?',
		hp: 20,
		dmg_resist: 3.5,
	},
	ams_soul_i: {
		name: 'Ams Soul I',
		bp: 7,
		hp: 10,
		pp: 3,
		tec_pot: 1,
	},
	ams_soul_ii: {
		name: 'Ams Soul II',
		bp: 8,
		hp: 10,
		pp: 3,
		tec_pot: 2,
	},
	ams_soul_ii_s: {
		name: 'Ams Soul II S',
		bp: 8,
		hp: 10,
		pp: 3,
		tec_pot: 2,
	},
	ams_soul_iii: {
		name: 'Ams Soul III',
		bp: 10,
		hp: 10,
		pp: 3,
		tec_pot: 2.5,
	},
	ams_soul_iii_s: {
		name: 'Ams Soul III S',
		bp: 10,
		hp: 10,
		pp: 3,
		tec_pot: 2.5,
	},
	ams_soul_iv: {
		name: 'Ams Soul IV',
		bp: '?',
		hp: 10,
		pp: 3,
		tec_pot: 3,
	},
	ams_soul_v: {
		name: 'Ams Soul V',
		bp: '?',
		hp: 10,
		pp: 3,
		tec_pot: 4,
	},
	belgan_note: {
		name: 'Belgan Note',
		bp: 5,
		pp: 3,
		mel_pot: 1.25,
		rng_pot: 1.25,
		tec_pot: 1.25,
	},
	blind_ward_i: {
		name: 'Blind Ward I',
		bp: 4,
		blind_resist: 20,
	},
	blind_ward_ii: {
		name: 'Blind Ward II',
		bp: 5,
		blind_resist: 25,
	},
	blind_ward_iii: {
		name: 'Blind Ward III',
		bp: 6,
		blind_resist: 30,
	},
	blind_ward_iii_s: {
		name: 'Blind Ward III S',
		bp: 6,
		blind_resist: 30,
	},
	blind_ward_iv: {
		name: 'Blind Ward IV',
		bp: 7,
		blind_resist: 35,
	},
	blind_ward_v: {
		name: 'Blind Ward V',
		bp: 8,
		blind_resist: 40,
	},
	burn_ward_i: {
		name: 'Burn Ward I',
		bp: 4,
		burn_resist: 20,
	},
	burn_ward_ii: {
		name: 'Burn Ward II',
		bp: 5,
		burn_resist: 25,
	},
	burn_ward_iii: {
		name: 'Burn Ward III',
		bp: 6,
		burn_resist: 30,
	},
	burn_ward_iii_s: {
		name: 'Burn Ward III S',
		bp: 6,
		burn_resist: 30,
	},
	burn_ward_iv: {
		name: 'Burn Ward IV',
		bp: 7,
		burn_resist: 35,
	},
	burn_ward_v: {
		name: 'Burn Ward V',
		bp: 8,
		burn_resist: 40,
	},
	crocys_soul_i: {
		name: 'Crocys Soul I',
		bp: 7,
		hp: 10,
		pp: 3,
		rng_pot: 1,
	},
	crocys_soul_ii: {
		name: 'Crocys Soul II',
		bp: 8,
		hp: 10,
		pp: 3,
		rng_pot: 2,
	},
	crocys_soul_ii_s: {
		name: 'Crocys Soul II S',
		bp: 8,
		hp: 10,
		pp: 3,
		rng_pot: 2,
	},
	crocys_soul_iii: {
		name: 'Crocys Soul III',
		bp: 10,
		hp: 10,
		pp: 3,
		rng_pot: 2.5,
	},
	crocys_soul_iii_s: {
		name: 'Crocys Soul III S',
		bp: 10,
		hp: 10,
		pp: 3,
		rng_pot: 2.5,
	},
	crocys_soul_iv: {
		name: 'Crocys Soul IV',
		bp: '?',
		hp: 10,
		pp: 3,
		rng_pot: 3,
	},
	crocys_soul_v: {
		name: 'Crocys Soul V',
		bp: '?',
		hp: 10,
		pp: 3,
		rng_pot: 4,
	},
	daityl_soul_i: {
		name: 'Daityl Soul I',
		bp: 7,
		pp: 5,
		mel_pot: 1,
	},
	daityl_soul_ii: {
		name: 'Daityl Soul II',
		bp: 8,
		pp: 5,
		mel_pot: 2,
	},
	daityl_soul_ii_s: {
		name: 'Daityl Soul II S',
		bp: 8,
		pp: 5,
		mel_pot: 2,
	},
	daityl_soul_iii: {
		name: 'Daityl Soul III',
		bp: 10,
		pp: 5,
		mel_pot: 2.5,
	},
	daityl_soul_iii_s: {
		name: 'Daityl Soul III S',
		bp: 10,
		pp: 5,
		mel_pot: 2.5,
	},
	daityl_soul_iv: {
		name: 'Daityl Soul IV',
		bp: '?',
		pp: 5,
		mel_pot: 3,
	},
	daityl_soul_v: {
		name: 'Daityl Soul V',
		bp: '?',
		pp: 5,
		mel_pot: 4,
	},
	dark_exploit_i: {
		name: 'Dark Exploit I',
		bp: 6,
		dark_pot: 2.5,
	},
	daytime_exploit_i: {
		name: 'Daytime Exploit I',
		bp: 6,
		daytime_pot: 2.5,
	},
	decold_might: {
		name: 'Decold Might',
		bp: 9,
		mel_pot: 2.5,
		low_temp_resist: 25,
	},
	decold_might_s: {
		name: 'Decold Might S',
		bp: 9,
		mel_pot: 2.5,
		low_temp_resist: 25,
	},
	decold_precision: {
		name: 'Decold Precision',
		bp: 9,
		rng_pot: 2.5,
		low_temp_resist: 25,
	},
	decold_precision_s: {
		name: 'Decold Precision S',
		bp: 9,
		rng_pot: 2.5,
		low_temp_resist: 25,
	},
	decold_standard_i: {
		name: 'Decold Standard I',
		bp: 1,
		low_temp_resist: 5,
	},
	decold_standard_i_s: {
		name: 'Decold Standard I S',
		bp: 1,
		low_temp_resist: 5,
	},
	decold_standard_ii: {
		name: 'Decold Standard II',
		bp: 3,
		low_temp_resist: 15,
	},
	decold_standard_ii_s: {
		name: 'Decold Standard II S',
		bp: 3,
		low_temp_resist: 15,
	},
	decold_standard_iii: {
		name: 'Decold Standard III',
		bp: 5,
		low_temp_resist: 25,
	},
	decold_standard_iii_s: {
		name: 'Decold Standard III S',
		bp: 5,
		low_temp_resist: 25,
	},
	decold_technique: {
		name: 'Decold Technique',
		bp: 9,
		tec_pot: 2.5,
		low_temp_resist: 25,
	},
	decold_technique_s: {
		name: 'Decold Technique S',
		bp: 9,
		tec_pot: 2.5,
		low_temp_resist: 25,
	},
	deft_might: {
		name: 'Deft Might',
		bp: 8,
		mel_pot: 2,
		pot_floor: 2,
	},
	deft_might_s: {
		name: 'Deft Might S',
		bp: 8,
		mel_pot: 2,
		pot_floor: 2,
	},
	deft_precision: {
		name: 'Deft Precision',
		bp: 8,
		rng_pot: 2,
		pot_floor: 2,
	},
	deft_precision_s: {
		name: 'Deft Precision S',
		bp: 8,
		rng_pot: 2,
		pot_floor: 2,
	},
	deft_technique: {
		name: 'Deft Technique',
		bp: 8,
		tec_pot: 2,
		pot_floor: 2,
	},
	deft_technique_s: {
		name: 'Deft Technique S',
		bp: 8,
		tec_pot: 2,
		pot_floor: 2,
	},
	deftness_i: {
		name: 'Deftness I',
		bp: 3,
		pot_floor: 1,
	},
	deftness_ii: {
		name: 'Deftness II',
		bp: 4,
		pot_floor: 1.5,
	},
	deftness_ii_s: {
		name: 'Deftness II S',
		bp: 4,
		pot_floor: 1.5,
	},
	deftness_iii: {
		name: 'Deftness III',
		bp: 5,
		pot_floor: 2,
	},
	deftness_iii_s: {
		name: 'Deftness III S',
		bp: 5,
		pot_floor: 2,
	},
	deftness_iv: {
		name: 'Deftness IV',
		bp: 6,
		pot_floor: 3,
	},
	deftness_v: {
		name: 'Deftness V',
		bp: 7,
		pot_floor: 4,
	},
	dolz_soul_i: {
		name: 'Dolz Soul I',
		bp: 5,
		pp: 5,
		pot_floor: 1,
	},
	dolz_soul_ii: {
		name: 'Dolz Soul II',
		bp: 6,
		pp: 5,
		pot_floor: 2,
	},
	dolz_soul_ii_s: {
		name: 'Dolz Soul II S',
		bp: 6,
		pot_floor: 2,
	},
	dolz_soul_iii: {
		name: 'Dolz Soul III',
		bp: 7,
		pp: 5,
		pot_floor: 2.5,
	},
	dolz_soul_iii_s: {
		name: 'Dolz Soul III S',
		bp: 7,
		pp: 5,
		pot_floor: 2.5,
	},
	dolz_soul_iv: {
		name: 'Dolz Soul IV',
		bp: '?',
		pp: 5,
		pot_floor: 3,
	},
	dolz_soul_v: {
		name: 'Dolz Soul V',
		bp: '?',
		pp: 5,
		pot_floor: 4,
	},
	dread_keeper_i: {
		name: 'Dread Keeper I',
		bp: 7,
		hp: 10,
		pp: 3,
		pot_floor: 1,
		dmg_resist: 1,
	},
	dread_keeper_ii: {
		name: 'Dread Keeper II',
		bp: 7.5,
		hp: 15,
		pp: 4,
		pot_floor: 1.5,
		dmg_resist: 1.5,
	},
	dread_keeper_ii_s: {
		name: 'Dread Keeper II S',
		bp: 7.5,
		hp: 15,
		pp: 4,
		pot_floor: 1.5,
		dmg_resist: 1.5,
	},
	dread_keeper_iii: {
		name: 'Dread Keeper III',
		bp: 10,
		hp: 30,
		pp: 7,
		pot_floor: 2,
		dmg_resist: 2,
	},
	dread_keeper_iv: {
		name: 'Dread Keeper IV',
		bp: '?',
		hp: 50,
		pp: 10,
		pot_floor: 6,
		dmg_resist: 3,
	},
	dread_keeper_v: {
		name: 'Dread Keeper V',
		bp: '?',
		hp: 70,
		pp: 15,
		pot_floor: 8,
		dmg_resist: 4,
	},
	dust_soul_i: {
		name: 'Dust Soul I',
		bp: 7,
		hp: 15,
		mel_pot: 1,
	},
	dust_soul_ii: {
		name: 'Dust Soul II',
		bp: 8,
		hp: 15,
		mel_pot: 2,
	},
	dust_soul_ii_s: {
		name: 'Dust Soul II S',
		bp: 8,
		hp: 15,
		mel_pot: 2,
	},
	dust_soul_iii: {
		name: 'Dust Soul III',
		bp: 10,
		hp: 15,
		mel_pot: 2.5,
	},
	dust_soul_iii_s: {
		name: 'Dust Soul III S',
		bp: 10,
		hp: 15,
		mel_pot: 2.5,
	},
	dust_soul_iv: {
		name: 'Dust Soul IV',
		bp: '?',
		hp: 15,
		mel_pot: 3,
	},
	dust_soul_v: {
		name: 'Dust Soul V',
		bp: '?',
		hp: 15,
		mel_pot: 4,
	},
	eradi_soul_i: {
		name: 'Eradi Soul I',
		bp: 7,
		hp: 10,
		pp: 4,
		mel_pot: 1.25,
		rng_pot: 1.25,
		tec_pot: 1.25,
	},
	eradi_soul_ii: {
		name: 'Eradi Soul II',
		bp: 8,
		hp: 10,
		pp: 4,
		mel_pot: 1.75,
		rng_pot: 1.75,
		tec_pot: 1.75,
	},
	eradi_soul_ii_s: {
		name: 'Eradi Soul II S',
		bp: 8,
		hp: 10,
		pp: 4,
		mel_pot: 1.75,
		rng_pot: 1.75,
		tec_pot: 1.75,
	},
	eradi_soul_iii: {
		name: 'Eradi Soul III',
		bp: 10,
		hp: 10,
		pp: 4,
		mel_pot: 2.25,
		rng_pot: 2.25,
		tec_pot: 2.25,
	},
	eradi_soul_iii_s: {
		name: 'Eradi Soul III S',
		bp: 10,
		hp: 10,
		pp: 4,
		mel_pot: 2.25,
		rng_pot: 2.25,
		tec_pot: 2.25,
	},
	eradi_soul_iv: {
		name: 'Eradi Soul IV',
		bp: '?',
		hp: 10,
		pp: 4,
		mel_pot: 2.75,
		rng_pot: 2.75,
		tec_pot: 2.75,
	},
	eradi_soul_v: {
		name: 'Eradi Soul V',
		bp: '?',
		hp: 10,
		pp: 4,
		mel_pot: 3.75,
		rng_pot: 3.75,
		tec_pot: 3.75,
	},
	esperio_i: {
		name: 'Esperio I',
		exp_grind: 400,
	},
	esperio_ii: {
		name: 'Esperio II',
		exp_grind: 450,
	},
	euphroy_soul_h: {
		name: 'Euphroy Soul H',
		bp: 11,
		hp: 15,
		mel_pot: 2.5,
		tec_pot: 2.5,
	},
	euphroy_soul_p: {
		name: 'Euphroy Soul P',
		bp: 11,
		pp: 5,
		mel_pot: 2.5,
		tec_pot: 2.5,
	},
	euphroy_soul_x: {
		name: 'Euphroy Soul X',
		bp: 11,
		hp: 10,
		pp: 3,
		mel_pot: 2.5,
		tec_pot: 2.5,
	},
	fire_exploit_i: {
		name: 'Fire Exploit I',
		bp: 6,
		fire_pot: 2.5,
	},
	forms_sand_soul_i: {
		name: 'Forms Sand Soul I',
		bp: 6,
		tec_pot: 2,
	},
	forms_sand_soul_ii: {
		name: 'Forms Sand Soul II',
		bp: 8,
		tec_pot: 2,
		dmg_resist: 2,
	},
	forms_sand_soul_ii_s: {
		name: 'Forms Sand Soul II S',
		bp: 8,
		tec_pot: 2,
		dmg_resist: 2,
	},
	forms_sand_soul_iii: {
		name: 'Forms Sand Soul III',
		bp: 9,
		tec_pot: 2,
		dmg_resist: 2.5,
	},
	forms_sand_soul_iii_s: {
		name: 'Forms Sand Soul III S',
		bp: 9,
		tec_pot: 2,
		dmg_resist: 2.5,
	},
	forms_sand_soul_iv: {
		name: 'Forms Sand Soul IV',
		bp: '?',
		tec_pot: 3,
		dmg_resist: 2,
	},
	forms_sand_soul_v: {
		name: 'Forms Sand Soul V',
		bp: '?',
		tec_pot: 4,
		dmg_resist: 2,
	},
	forms_soul_i: {
		name: 'Forms Soul I',
		bp: 6,
		mel_pot: 2,
	},
	forms_soul_ii: {
		name: 'Forms Soul II',
		bp: 8,
		mel_pot: 2,
		dmg_resist: 2,
	},
	forms_soul_ii_s: {
		name: 'Forms Soul II S',
		bp: 8,
		mel_pot: 2,
		dmg_resist: 2,
	},
	forms_soul_iii: {
		name: 'Forms Soul III',
		bp: 9,
		mel_pot: 2,
		dmg_resist: 2.5,
	},
	forms_soul_iii_s: {
		name: 'Forms Soul III S',
		bp: 9,
		mel_pot: 2,
		dmg_resist: 2.5,
	},
	forms_soul_iv: {
		name: 'Forms Soul IV',
		bp: '?',
		mel_pot: 3,
		dmg_resist: 2,
	},
	forms_soul_v: {
		name: 'Forms Soul V',
		bp: '?',
		mel_pot: 4,
		dmg_resist: 2,
	},
	forms_machini_soul_i: {
		name: 'Forms Machini Soul I',
		bp: 6,
		rng_pot: 2,
	},
	forms_machini_soul_ii: {
		name: 'Forms Machini Soul II',
		bp: 8,
		rng_pot: 2,
		dmg_resist: 2,
	},
	forms_machini_soul_ii_s: {
		name: 'Forms Machini Soul II S',
		bp: 8,
		rng_pot: 2,
		dmg_resist: 2,
	},
	forms_machini_soul_iii: {
		name: 'Forms Machini Soul III',
		bp: 9,
		rng_pot: 2,
		dmg_resist: 2.5,
	},
	forms_machini_soul_iii_s: {
		name: 'Forms Machini Soul III S',
		bp: 9,
		rng_pot: 2,
		dmg_resist: 2.5,
	},
	forms_machini_soul_iv: {
		name: 'Forms Machini Soul IV',
		bp: '?',
		rng_pot: 3,
		dmg_resist: 2,
	},
	forms_machini_soul_v: {
		name: 'Forms Machini Soul V',
		bp: '?',
		rng_pot: 4,
		dmg_resist: 2,
	},
	freeze_ward_i: {
		name: 'Freeze Ward I',
		bp: 4,
		freeze_resist: 20,
	},
	freeze_ward_ii: {
		name: 'Freeze Ward II',
		bp: 5,
		freeze_resist: 25,
	},
	freeze_ward_iii: {
		name: 'Freeze Ward III',
		bp: 6,
		freeze_resist: 30,
	},
	freeze_ward_iii_s: {
		name: 'Freeze Ward III S',
		bp: 6,
		freeze_resist: 30,
	},
	freeze_ward_iv: {
		name: 'Freeze Ward IV',
		bp: 7,
		freeze_resist: 35,
	},
	freeze_ward_v: {
		name: 'Freeze Ward V',
		bp: 8,
		freeze_resist: 40,
	},
	frostyl_soul_i: {
		name: 'Frostyl Soul I',
		bp: 7,
		hp: 10,
		pp: 3,
		mel_pot: 1,
	},
	frostyl_soul_ii: {
		name: 'Frostyl Soul II',
		bp: 8,
		hp: 10,
		pp: 3,
		mel_pot: 2,
	},
	frostyl_soul_ii_s: {
		name: 'Frostyl Soul II S',
		bp: 8,
		hp: 10,
		pp: 3,
		mel_pot: 2,
	},
	frostyl_soul_iii: {
		name: 'Frostyl Soul III',
		bp: 10,
		hp: 10,
		pp: 3,
		mel_pot: 2.5,
	},
	frostyl_soul_iii_s: {
		name: 'Frostyl Soul III S',
		bp: 10,
		hp: 10,
		pp: 3,
		mel_pot: 2.5,
	},
	frostyl_soul_iv: {
		name: 'Frostyl Soul IV',
		bp: '?',
		hp: 10,
		pp: 3,
		mel_pot: 3,
	},
	frostyl_soul_v: {
		name: 'Frostyl Soul V',
		bp: '?',
		hp: 10,
		pp: 3,
		mel_pot: 4,
	},
	gigas_aglai: {
		name: 'Gigas Aglai',
		bp: 11,
		hp: 15,
		mel_pot: 2.5,
		rng_pot: 2.5,
	},
	gigas_euphroy: {
		name: 'Gigas Euphroy',
		bp: 11,
		hp: 15,
		mel_pot: 2.5,
		tec_pot: 2.5,
	},
	gigas_might_i: {
		name: 'Gigas Might I',
		bp: 6,
		hp: 5,
		mel_pot: 1.5,
	},
	gigas_might_ii: {
		name: 'Gigas Might II',
		bp: 8,
		hp: 10,
		mel_pot: 2,
	},
	gigas_might_ii_s: {
		name: 'Gigas Might II S',
		bp: 8,
		hp: 10,
		mel_pot: 2,
	},
	gigas_might_iii: {
		name: 'Gigas Might III',
		bp: 10,
		hp: 15,
		mel_pot: 2.5,
	},
	gigas_might_iii_s: {
		name: 'Gigas Might III S',
		bp: 10,
		hp: 15,
		mel_pot: 2.5,
	},
	gigas_might_iv: {
		name: 'Gigas Might IV',
		bp: '?',
		hp: 20,
		mel_pot: 3,
	},
	gigas_might_v: {
		name: 'Gigas Might V',
		bp: '?',
		hp: 25,
		mel_pot: 4,
	},
	gigas_precision_i: {
		name: 'Gigas Precision I',
		bp: 6,
		hp: 5,
		rng_pot: 1.5,
	},
	gigas_precision_ii: {
		name: 'Gigas Precision II',
		bp: 8,
		hp: 10,
		rng_pot: 2,
	},
	gigas_precision_ii_s: {
		name: 'Gigas Precision II S',
		bp: 8,
		hp: 10,
		rng_pot: 2,
	},
	gigas_precision_iii: {
		name: 'Gigas Precision III',
		bp: 10,
		hp: 15,
		rng_pot: 2.5,
	},
	gigas_precision_iii_s: {
		name: 'Gigas Precision III S',
		bp: 10,
		hp: 15,
		rng_pot: 2.5,
	},
	gigas_precision_iv: {
		name: 'Gigas Precision IV',
		bp: '?',
		hp: 20,
		rng_pot: 3,
	},
	gigas_precision_v: {
		name: 'Gigas Precision V',
		bp: '?',
		hp: 25,
		rng_pot: 4,
	},
	gigas_technique_i: {
		name: 'Gigas Technique I',
		bp: 6,
		hp: 5,
		tec_pot: 1.5,
	},
	gigas_technique_ii: {
		name: 'Gigas Technique II',
		bp: 8,
		hp: 10,
		tec_pot: 2,
	},
	gigas_technique_ii_s: {
		name: 'Gigas Technique II S',
		bp: 8,
		hp: 10,
		tec_pot: 2,
	},
	gigas_technique_iii: {
		name: 'Gigas Technique III',
		bp: 10,
		hp: 15,
		tec_pot: 2.5,
	},
	gigas_technique_iii_s: {
		name: 'Gigas Technique III S',
		bp: 10,
		hp: 15,
		tec_pot: 2.5,
	},
	gigas_technique_iv: {
		name: 'Gigas Technique IV',
		bp: '?',
		hp: 20,
		tec_pot: 3,
	},
	gigas_technique_v: {
		name: 'Gigas Technique V',
		bp: '?',
		hp: 25,
		tec_pot: 4,
	},
	gigas_thali: {
		name: 'Gigas Thali',
		bp: 11,
		hp: 15,
		rng_pot: 2.5,
		tec_pot: 2.5,
	},
	gua_might: {
		name: 'Gua Might',
		bp: 8,
		mel_pot: 2,
		dmg_resist: 2,
	},
	gua_might_s: {
		name: 'Gua Might S',
		bp: 8,
		mel_pot: 2,
		dmg_resist: 2,
	},
	gua_precision: {
		name: 'Gua Precision',
		bp: 8,
		rng_pot: 2,
		dmg_resist: 2,
	},
	gua_precision_s: {
		name: 'Gua Precision S',
		bp: 8,
		rng_pot: 2,
		dmg_resist: 2,
	},
	gua_technique: {
		name: 'Gua Technique',
		bp: 8,
		tec_pot: 2,
		dmg_resist: 2,
	},
	gua_technique_s: {
		name: 'Gua Technique S',
		bp: 8,
		tec_pot: 2,
		dmg_resist: 2,
	},
	guard_i: {
		name: 'Guard I',
		bp: 2,
		dmg_resist: 1,
	},
	guard_ii: {
		name: 'Guard II',
		bp: 3,
		dmg_resist: 1.5,
	},
	guard_ii_s: {
		name: 'Guard II S',
		bp: 3,
		dmg_resist: 1.5,
	},
	guard_iii: {
		name: 'Guard III',
		bp: 4,
		dmg_resist: 2,
	},
	guard_iii_s: {
		name: 'Guard III S',
		bp: 4,
		dmg_resist: 2,
	},
	guard_iv: {
		name: 'Guard IV',
		bp: 5,
		dmg_resist: 3,
	},
	guard_v: {
		name: 'Guard V',
		bp: 6,
		dmg_resist: 4,
	},
	halphis_note: {
		name: 'Halphis Note',
		bp: '?',
	},
	hi_perio: {
		name: 'Hi Perio',
		exp_grind: 5000,
	},
	ice_exploit_i: {
		name: 'Ice Exploit I',
		bp: 6,
		ice_pot: 2.5,
	},
	kvar_note_a: {
		name: 'Kvar Note A',
		bp: 5,
		hp: 10,
		pp: 5,
	},
	kvar_note_b: {
		name: 'Kvar Note B',
		bp: 4,
		mel_pot: 2,
		rng_pot: 2,
		dmg_resist: -2,
	},
	kvar_note_c: {
		name: 'Kvar Note C',
		bp: 4,
		mel_pot: 2,
		tec_pot: 2,
		dmg_resist: -2,
	},
	kvar_note_d: {
		name: 'Kvar Note D',
		bp: 4,
		rng_pot: 2,
		tec_pot: 2,
		dmg_resist: -2,
	},
	kvar_domina: {
		name: 'Kvar Domina',
		bp: 10,
		pp: 5,
		mel_pot: 2,
		rng_pot: 2,
		tec_pot: 2,
		dmg_resist: -2,
	},
	kvar_domina_s: {
		name: 'Kvar Domina S',
		bp: 10,
		pp: 5,
		mel_pot: 2,
		rng_pot: 2,
		tec_pot: 2,
		dmg_resist: -2,
	},
	kvar_domina_ii: {
		name: 'Kvar Domina II',
		bp: '?',
	},
	lab_note: {
		name: 'Lab Note',
		bp: 5,
		rng_pot: 1.5,
	},
	light_exploit_i: {
		name: 'Light Exploit I',
		bp: 6,
		light_pot: 2.5,
	},
	lightning_exploit_i: {
		name: 'Lightning Exploit I',
		bp: 6,
		lightning_pot: 2.5,
	},
	lostral_note: {
		name: 'Lostral Note',
		bp: 5,
		hp: 10,
		mel_pot: 1.25,
		rng_pot: 1.25,
		tec_pot: 1.25,
	},
	magnus_note: {
		name: 'Magnus Note',
		bp: 5,
		mel_pot: 1.5,
	},
	maqea_note: {
		name: 'Maqea Note',
		bp: 5,
		mel_pot: 1.25,
		rng_pot: 1.25,
		tec_pot: 1.25,
	},
	mastery_i: {
		name: 'Mastery I',
		bp: 6,
		mel_pot: 0.5,
		rng_pot: 0.5,
		tec_pot: 0.5,
		pot_floor: 0.5,
		dmg_resist: 0.5,
	},
	mastery_i_s: {
		name: 'Mastery I S',
		bp: 6,
		mel_pot: 0.5,
		rng_pot: 0.5,
		tec_pot: 0.5,
		pot_floor: 0.5,
		dmg_resist: 0.5,
	},
	mastery_ii: {
		name: 'Mastery II',
		bp: 8,
		mel_pot: 1,
		rng_pot: 1,
		tec_pot: 1,
		pot_floor: 1,
		dmg_resist: 1,
	},
	mastery_ii_s: {
		name: 'Mastery II S',
		bp: 8,
		mel_pot: 1,
		rng_pot: 1,
		tec_pot: 1,
		pot_floor: 1,
		dmg_resist: 1,
	},
	mastery_iii: {
		name: 'Mastery III',
		bp: 10,
		mel_pot: 1.5,
		rng_pot: 1.5,
		tec_pot: 1.5,
		pot_floor: 1.5,
		dmg_resist: 1.5,
	},
	mastery_iii_s: {
		name: 'Mastery III S',
		bp: 10,
		mel_pot: 1.5,
		rng_pot: 1.5,
		tec_pot: 1.5,
		pot_floor: 1.5,
		dmg_resist: 1.5,
	},
	mastery_iv: {
		name: 'Mastery IV',
		bp: 12,
		mel_pot: 2.5,
		rng_pot: 2.5,
		tec_pot: 2.5,
		pot_floor: 2.5,
		dmg_resist: 2.5,
	},
	mastery_iv_s: {
		name: 'Mastery IV S',
		bp: 12,
		mel_pot: 2.5,
		rng_pot: 2.5,
		tec_pot: 2.5,
		pot_floor: 2.5,
		dmg_resist: 2.5,
	},
	mastery_v: {
		name: 'Mastery V',
		bp: '?',
		mel_pot: 3.5,
		rng_pot: 3.5,
		tec_pot: 3.5,
		pot_floor: 3.5,
		dmg_resist: 3.5,
	},
	megas_fusia: {
		name: 'Megas Fusia',
		bp: 4,
		mel_pot: 1,
		rng_pot: 1,
		tec_pot: 1,
	},
	melra_dualble_i: {
		name: 'Melra Dualble I',
		bp: 4,
		mel_pot: 0.75,
		rng_pot: 0.75,
	},
	melra_dualble_ii: {
		name: 'Melra Dualble II',
		bp: 5,
		mel_pot: 1.25,
		rng_pot: 1.25,
	},
	melra_dualble_ii_s: {
		name: 'Melra Dualble II S',
		bp: 5,
		mel_pot: 1.25,
		rng_pot: 1.25,
	},
	melra_dualble_iii: {
		name: 'Melra Dualble III',
		bp: 6,
		mel_pot: 1.75,
		rng_pot: 1.75,
	},
	melra_dualble_iii_s: {
		name: 'Melra Dualble III S',
		bp: 6,
		mel_pot: 1.75,
		rng_pot: 1.75,
	},
	melra_dualble_iv: {
		name: 'Melra Dualble IV',
		bp: '?',
		mel_pot: 2.75,
		rng_pot: 2.75,
	},
	melra_dualble_v: {
		name: 'Melra Dualble V',
		bp: '?',
		mel_pot: 3.75,
		rng_pot: 3.75,
	},
	meltech_dualble_i: {
		name: 'Meltech Dualble I',
		bp: 4,
		mel_pot: 0.75,
		tec_pot: 0.75,
	},
	meltech_dualble_ii: {
		name: 'Meltech Dualble II',
		bp: 5,
		mel_pot: 1.25,
		tec_pot: 1.25,
	},
	meltech_dualble_ii_s: {
		name: 'Meltech Dualble II S',
		bp: 5,
		mel_pot: 1.25,
		tec_pot: 1.25,
	},
	meltech_dualble_iii: {
		name: 'Meltech Dualble III',
		bp: 6,
		mel_pot: 1.75,
		tec_pot: 1.75,
	},
	meltech_dualble_iii_s: {
		name: 'Meltech Dualble III S',
		bp: 6,
		mel_pot: 1.75,
		tec_pot: 1.75,
	},
	meltech_dualble_iv: {
		name: 'Meltech Dualble IV',
		bp: '?',
		mel_pot: 2.75,
		tec_pot: 2.75,
	},
	meltech_dualble_v: {
		name: 'Meltech Dualble V',
		bp: '?',
		mel_pot: 3.75,
		tec_pot: 3.75,
	},
	might_i: {
		name: 'Might I',
		bp: 4,
		mel_pot: 1,
	},
	might_ii: {
		name: 'Might II',
		bp: 5,
		mel_pot: 1.5,
	},
	might_ii_s: {
		name: 'Might II S',
		bp: 5,
		mel_pot: 1.5,
	},
	might_iii: {
		name: 'Might III',
		bp: 6,
		mel_pot: 2,
	},
	might_iii_s: {
		name: 'Might III S',
		bp: 6,
		mel_pot: 2,
	},
	might_iv: {
		name: 'Might IV',
		bp: 7,
		mel_pot: 3,
	},
	might_v: {
		name: 'Might V',
		bp: 8,
		mel_pot: 4,
	},
	nex_soul_i: {
		name: 'Nex Soul I',
		bp: 7,
		pp: 5,
		tec_pot: 1,
	},
	nex_soul_ii: {
		name: 'Nex Soul II',
		bp: 8,
		pp: 5,
		tec_pot: 2,
	},
	nex_soul_ii_s: {
		name: 'Nex Soul II S',
		bp: 8,
		pp: 5,
		tec_pot: 2,
	},
	nex_soul_iii: {
		name: 'Nex Soul III',
		bp: 10,
		pp: 5,
		tec_pot: 2.5,
	},
	nex_soul_iii_s: {
		name: 'Nex Soul III S',
		bp: 10,
		pp: 5,
		tec_pot: 2.5,
	},
	nex_soul_iv: {
		name: 'Nex Soul IV',
		bp: '?',
		pp: 5,
		tec_pot: 3,
	},
	nex_soul_v: {
		name: 'Nex Soul V',
		bp: '?',
		pp: 5,
		tec_pot: 4,
	},
	nighttime_exploit_i: {
		name: 'Nighttime Exploit I',
		bp: 6,
		nighttime_pot: 2.5,
	},
	pain_ward_i: {
		name: 'Pain Ward I',
		bp: 4,
		pain_resist: 20,
	},
	pain_ward_ii: {
		name: 'Pain Ward II',
		bp: 5,
		pain_resist: 25,
	},
	pain_ward_iii: {
		name: 'Pain Ward III',
		bp: 6,
		pain_resist: 30,
	},
	pain_ward_iii_s: {
		name: 'Pain Ward III S',
		bp: 6,
		pain_resist: 30,
	},
	pain_ward_iv: {
		name: 'Pain Ward IV',
		bp: 7,
		pain_resist: 35,
	},
	pain_ward_v: {
		name: 'Pain Ward V',
		bp: 8,
		pain_resist: 40,
	},
	panic_ward_i: {
		name: 'Panic Ward I',
		bp: 4,
		panic_resist: 20,
	},
	panic_ward_ii: {
		name: 'Panic Ward II',
		bp: 5,
		panic_resist: 25,
	},
	panic_ward_iii: {
		name: 'Panic Ward III',
		bp: 6,
		panic_resist: 30,
	},
	panic_ward_iii_s: {
		name: 'Panic Ward III S',
		bp: 6,
		panic_resist: 30,
	},
	panic_ward_iv: {
		name: 'Panic Ward IV',
		bp: 7,
		panic_resist: 35,
	},
	panic_ward_v: {
		name: 'Panic Ward V',
		bp: 8,
		panic_resist: 40,
	},
	pettas_soul_i: {
		name: 'Pettas Soul I',
		bp: 7,
		pp: 5,
		rng_pot: 1,
	},
	pettas_soul_ii: {
		name: 'Pettas Soul II',
		bp: 8,
		pp: 5,
		rng_pot: 2,
	},
	pettas_soul_ii_s: {
		name: 'Pettas Soul II S',
		bp: 8,
		pp: 5,
		rng_pot: 2,
	},
	pettas_soul_iii: {
		name: 'Pettas Soul III',
		bp: 10,
		pp: 5,
		rng_pot: 2.5,
	},
	pettas_soul_iii_s: {
		name: 'Pettas Soul III S',
		bp: 10,
		pp: 5,
		rng_pot: 2.5,
	},
	pettas_soul_iv: {
		name: 'Pettas Soul IV',
		bp: '?',
		pp: 5,
		rng_pot: 3,
	},
	pettas_soul_v: {
		name: 'Pettas Soul V',
		bp: '?',
		pp: 5,
		rng_pot: 4,
	},
	poison_ward_i: {
		name: 'Poison Ward I',
		bp: 4,
		poison_resist: 20,
	},
	poison_ward_ii: {
		name: 'Poison Ward II',
		bp: 5,
		poison_resist: 25,
	},
	poison_ward_iii: {
		name: 'Poison Ward III',
		bp: 6,
		poison_resist: 30,
	},
	poison_ward_iii_s: {
		name: 'Poison Ward III S',
		bp: 6,
		poison_resist: 30,
	},
	poison_ward_iv: {
		name: 'Poison Ward IV',
		bp: 7,
		poison_resist: 35,
	},
	poison_ward_v: {
		name: 'Poison Ward V',
		bp: 8,
		poison_resist: 40,
	},
	precision_i: {
		name: 'Precision I',
		bp: 4,
		rng_pot: 1,
	},
	precision_ii: {
		name: 'Precision II',
		bp: 5,
		rng_pot: 1.5,
	},
	precision_ii_s: {
		name: 'Precision II S',
		bp: 5,
		rng_pot: 1.5,
	},
	precision_iii: {
		name: 'Precision III',
		bp: 6,
		rng_pot: 2,
	},
	precision_iii_s: {
		name: 'Precision III S',
		bp: 6,
		rng_pot: 2,
	},
	precision_iv: {
		name: 'Precision IV',
		bp: 7,
		rng_pot: 3,
	},
	precision_v: {
		name: 'Precision V',
		bp: 8,
		rng_pot: 4,
	},
	ragras_soul_i: {
		name: 'Ragras Soul I',
		bp: 7,
		hp: 15,
		rng_pot: 1,
	},
	ragras_soul_ii: {
		name: 'Ragras Soul II',
		bp: 8,
		hp: 15,
		rng_pot: 2,
	},
	ragras_soul_ii_s: {
		name: 'Ragras Soul II S',
		bp: 8,
		hp: 15,
		rng_pot: 2,
	},
	ragras_soul_iii: {
		name: 'Ragras Soul III',
		bp: 10,
		hp: 15,
		rng_pot: 2.5,
	},
	ragras_soul_iii_s: {
		name: 'Ragras Soul III S',
		bp: 10,
		hp: 15,
		rng_pot: 2.5,
	},
	ragras_soul_iv: {
		name: 'Ragras Soul IV',
		bp: '?',
		hp: 15,
		rng_pot: 3,
	},
	ragras_soul_v: {
		name: 'Ragras Soul V',
		bp: '?',
		hp: 15,
		rng_pot: 4,
	},
	ratech_dualble_i: {
		name: 'Ratech Dualble I',
		bp: 4,
		rng_pot: 0.75,
		tec_pot: 0.75,
	},
	ratech_dualble_ii: {
		name: 'Ratech Dualble II',
		bp: 5,
		rng_pot: 1.25,
		tec_pot: 1.25,
	},
	ratech_dualble_ii_s: {
		name: 'Ratech Dualble II S',
		bp: 5,
		rng_pot: 1.25,
		tec_pot: 1.25,
	},
	ratech_dualble_iii: {
		name: 'Ratech Dualble III',
		bp: 6,
		rng_pot: 1.75,
		tec_pot: 1.75,
	},
	ratech_dualble_iii_s: {
		name: 'Ratech Dualble III S',
		bp: 6,
		rng_pot: 1.75,
		tec_pot: 1.75,
	},
	ratech_dualble_iv: {
		name: 'Ratech Dualble IV',
		bp: '?',
		rng_pot: 2.75,
		tec_pot: 2.75,
	},
	ratech_dualble_v: {
		name: 'Ratech Dualble V',
		bp: '?',
		rng_pot: 3.75,
		tec_pot: 3.75,
	},
	renus_soul_i: {
		name: 'Renus Soul I',
		bp: 7,
		hp: 15,
		tec_pot: 1,
	},
	renus_soul_ii: {
		name: 'Renus Soul II',
		bp: 8,
		hp: 15,
		tec_pot: 2,
	},
	renus_soul_ii_s: {
		name: 'Renus Soul II S',
		bp: 8,
		hp: 15,
		tec_pot: 2,
	},
	renus_soul_iii: {
		name: 'Renus Soul III',
		bp: 10,
		hp: 15,
		tec_pot: 2.5,
	},
	renus_soul_iii_s: {
		name: 'Renus Soul III S',
		bp: 10,
		hp: 15,
		tec_pot: 2.5,
	},
	renus_soul_iv: {
		name: 'Renus Soul IV',
		bp: '?',
		hp: 15,
		tec_pot: 3,
	},
	renus_soul_v: {
		name: 'Renus Soul V',
		bp: '?',
		hp: 15,
		tec_pot: 4,
	},
	resola_note: {
		name: 'Resola Note',
		bp: 5,
		tec_pot: 1.5,
	},
	ret_domina: {
		name: 'Ret Domina',
		bp: 10,
		hp: 15,
		mel_pot: 1.5,
		rng_pot: 1.5,
		tec_pot: 1.5,
	},
	ret_domina_ii: {
		name: 'Ret Domina II',
		bp: '?',
	},
	ret_note_a: {
		name: 'Ret Note A',
		bp: 5,
		hp: 10,
	},
	ret_note_b: {
		name: 'Ret Note B',
		bp: 4,
		hp: 5,
		mel_pot: 0.75,
		rng_pot: 0.75,
	},
	ret_note_c: {
		name: 'Ret Note C',
		bp: 4,
		hp: 5,
		mel_pot: 0.75,
		tec_pot: 0.75,
	},
	ret_note_d: {
		name: 'Ret Note D',
		bp: 4,
		hp: 5,
		rng_pot: 0.75,
		tec_pot: 0.75,
	},
	sezun_lunafiv: {
		name: 'Sezun Lunafiv',
		bp: 10,
		seasonal_pot: 15,
		seasonal_crit: 20,
		seasonal_drop: 25,
	},
	sezun_automfevre: {
		name: 'Sezun Automfevre',
		bp: '?',
		seasonal_pot: 5,
		seasonal_crit: 20,
		seasonal_drop: 25,
	},
	shock_ward_i: {
		name: 'Shock Ward I',
		bp: 4,
		shock_resist: 20,
	},
	shock_ward_ii: {
		name: 'Shock Ward II',
		bp: 5,
		shock_resist: 25,
	},
	shock_ward_iii: {
		name: 'Shock Ward III',
		bp: 6,
		shock_resist: 30,
	},
	shock_ward_iii_s: {
		name: 'Shock Ward III S',
		bp: 6,
		shock_resist: 30,
	},
	shock_ward_iv: {
		name: 'Shock Ward IV',
		bp: 7,
		shock_resist: 35,
	},
	shock_ward_v: {
		name: 'Shock Ward V',
		bp: 8,
		shock_resist: 40,
	},
	sovereign_ward_i: {
		name: 'Sovereign Ward I',
		bp: 6,
		all_resist: 20,
	},
	sovereign_ward_i_s: {
		name: 'Sovereign Ward I S',
		bp: 6,
		all_resist: 20,
	},
	sovereign_ward_ii: {
		name: 'Sovereign Ward II',
		bp: 8,
		all_resist: 25,
	},
	sovereign_ward_ii_s: {
		name: 'Sovereign Ward II S',
		bp: 8,
		all_resist: 25,
	},
	sovereign_ward_iii: {
		name: 'Sovereign Ward III',
		bp: 10,
		all_resist: 30,
	},
	sovereign_ward_iv: {
		name: 'Sovereign Ward IV',
		bp: 12,
		all_resist: 35,
	},
	sovereign_ward_v: {
		name: 'Sovereign Ward V',
		bp: 14,
		all_resist: 40,
	},
	spi_might: {
		name: 'Spi Might',
		bp: 8,
		pp: 5,
		mel_pot: 2,
	},
	spi_might_s: {
		name: 'Spi Might S',
		bp: 8,
		pp: 5,
		mel_pot: 2,
	},
	spi_precision: {
		name: 'Spi Precision',
		bp: 8,
		pp: 5,
		rng_pot: 2,
	},
	spi_precision_s: {
		name: 'Spi Precision S',
		bp: 8,
		pp: 5,
		rng_pot: 2,
	},
	spi_technique: {
		name: 'Spi Technique',
		bp: 8,
		pp: 5,
		tec_pot: 2,
	},
	spi_technique_s: {
		name: 'Spi Technique S',
		bp: 8,
		pp: 5,
		tec_pot: 2,
	},
	spirit_i: {
		name: 'Spirit I',
		bp: 2,
		pp: 3,
	},
	spirit_ii: {
		name: 'Spirit II',
		bp: 3,
		pp: 4,
	},
	spirit_ii_s: {
		name: 'Spirit II S',
		bp: 3,
		pp: 4,
	},
	spirit_iii: {
		name: 'Spirit III',
		bp: 4,
		pp: 5,
	},
	spirit_iii_s: {
		name: 'Spirit III S',
		bp: 4,
		pp: 5,
	},
	spirit_iv: {
		name: 'Spirit IV',
		bp: 5,
		pp: 6,
	},
	spirit_v: {
		name: 'Spirit V',
		bp: 6,
		pp: 7,
	},
	sta_might: {
		name: 'Sta Might',
		bp: 8,
		hp: 15,
		mel_pot: 2,
	},
	sta_might_s: {
		name: 'Sta Might S',
		bp: 8,
		hp: 15,
		mel_pot: 2,
	},
	sta_precision: {
		name: 'Sta Precision',
		bp: 8,
		hp: 15,
		rng_pot: 2,
	},
	sta_precision_s: {
		name: 'Sta Precision S',
		bp: 8,
		hp: 15,
		rng_pot: 2,
	},
	sta_technique: {
		name: 'Sta Technique',
		bp: 8,
		hp: 15,
		tec_pot: 2,
	},
	sta_technique_s: {
		name: 'Sta Technique S',
		bp: 8,
		hp: 15,
		tec_pot: 2,
	},
	stamina_i: {
		name: 'Stamina I',
		bp: 3,
		hp: 5,
	},
	stamina_ii: {
		name: 'Stamina II',
		bp: 4,
		hp: 10,
	},
	stamina_ii_s: {
		name: 'Stamina II S',
		bp: 4,
		hp: 10,
	},
	stamina_iii: {
		name: 'Stamina III',
		bp: 5,
		hp: 15,
	},
	stamina_iii_s: {
		name: 'Stamina III S',
		bp: 5,
		hp: 15,
	},
	stamina_iv: {
		name: 'Stamina IV',
		bp: 6,
		hp: 20,
	},
	stamina_v: {
		name: 'Stamina V',
		bp: 7,
		hp: 25,
	},
	super_might_i: {
		name: 'Super Might I',
		bp: 8,
		mel_pot: 2.25,
	},
	super_might_i_s: {
		name: 'Super Might I S',
		bp: 8,
		mel_pot: 2.25,
	},
	super_precision_i: {
		name: 'Super Precision I',
		bp: 8,
		rng_pot: 2.25,
	},
	super_precision_i_s: {
		name: 'Super Precision I S',
		bp: 8,
		rng_pot: 2.25,
	},
	super_spimel_i: {
		name: 'Super Spimel I',
		bp: 8,
		pp: 5,
		mel_pot: 2,
	},
	super_spimel_i_s: {
		name: 'Super Spimel I S',
		bp: 8,
		pp: 5,
		mel_pot: 2,
	},
	super_spira_i: {
		name: 'Super Spira I',
		bp: 8,
		pp: 5,
		rng_pot: 2,
	},
	super_spira_i_s: {
		name: 'Super Spira I S',
		bp: 8,
		pp: 5,
		rng_pot: 2,
	},
	super_spitech_i: {
		name: 'Super Spitech I',
		bp: 8,
		pp: 5,
		tec_pot: 2,
	},
	super_spitech_i_s: {
		name: 'Super Spitech I S',
		bp: 8,
		pp: 5,
		tec_pot: 2,
	},
	super_stamel_i: {
		name: 'Super Stamel I',
		bp: 8,
		hp: 15,
		mel_pot: 2,
	},
	super_stamel_i_s: {
		name: 'Super Stamel I S',
		bp: 8,
		hp: 15,
		mel_pot: 2,
	},
	super_stara_i: {
		name: 'Super Stara I',
		bp: 8,
		hp: 15,
		rng_pot: 2,
	},
	super_stara_i_s: {
		name: 'Super Stara I S',
		bp: 8,
		hp: 15,
		rng_pot: 2,
	},
	super_statech_i: {
		name: 'Super Statech I',
		bp: 8,
		hp: 15,
		tec_pot: 2,
	},
	super_statech_i_s: {
		name: 'Super Statech I S',
		bp: 8,
		hp: 15,
		tec_pot: 2,
	},
	super_technique_i: {
		name: 'Super Technique I',
		bp: 8,
		tec_pot: 2.25,
	},
	super_technique_i_s: {
		name: 'Super Technique I S',
		bp: 8,
		tec_pot: 2.25,
	},
	technique_i: {
		name: 'Technique I',
		bp: 4,
		tec_pot: 1,
	},
	technique_ii: {
		name: 'Technique II',
		bp: 5,
		tec_pot: 1.5,
	},
	technique_ii_s: {
		name: 'Technique II S',
		bp: 5,
		tec_pot: 1.5,
	},
	technique_iii: {
		name: 'Technique III',
		bp: 6,
		tec_pot: 2,
	},
	technique_iii_s: {
		name: 'Technique III S',
		bp: 6,
		tec_pot: 2,
	},
	technique_iv: {
		name: 'Technique IV',
		bp: 7,
		tec_pot: 3,
	},
	technique_v: {
		name: 'Technique V',
		bp: 8,
		tec_pot: 4,
	},
	thali_soul_h: {
		name: 'Thali Soul H',
		bp: 11,
		hp: 15,
		rng_pot: 2.5,
		tec_pot: 2.5,
	},
	thali_soul_p: {
		name: 'Thali Soul P',
		bp: 11,
		pp: 5,
		rng_pot: 2.5,
		tec_pot: 2.5,
	},
	thali_soul_x: {
		name: 'Thali Soul X',
		bp: 11,
		hp: 10,
		pp: 3,
		rng_pot: 2.5,
		tec_pot: 2.5,
	},
	tria_deftromel: {
		name: 'Tria Deftromel',
		bp: 6,
		mel_pot: 2.25,
		pot_floor: -1,
	},
	tria_deftromel_s: {
		name: 'Tria Deftromel S',
		bp: 6,
		mel_pot: 2.25,
		pot_floor: -1,
	},
	tria_deftrora: {
		name: 'Tria Deftrora',
		bp: 6,
		rng_pot: 2.25,
		pot_floor: -1,
	},
	tria_deftrora_s: {
		name: 'Tria Deftrora S',
		bp: 6,
		rng_pot: 2.25,
		pot_floor: -1,
	},
	tria_deftrotech: {
		name: 'Tria Deftrotech',
		bp: 6,
		tec_pot: 2.25,
		pot_floor: -1,
	},
	tria_deftrotech_s: {
		name: 'Tria Deftrotech S',
		bp: 6,
		tec_pot: 2.25,
		pot_floor: -1,
	},
	tria_guaromel: {
		name: 'Tria Guaromel',
		bp: 6,
		mel_pot: 2.25,
		dmg_resist: -1,
	},
	tria_guaromel_s: {
		name: 'Tria Guaromel S',
		bp: 6,
		mel_pot: 2.25,
		dmg_resist: -1,
	},
	tria_guarora: {
		name: 'Tria Guarora',
		bp: 6,
		rng_pot: 2.25,
		dmg_resist: -1,
	},
	tria_guarora_s: {
		name: 'Tria Guarora S',
		bp: 6,
		rng_pot: 2.25,
		dmg_resist: -1,
	},
	tria_guarotech: {
		name: 'Tria Guarotech',
		bp: 6,
		tec_pot: 2.25,
		dmg_resist: -1,
	},
	tria_guarotech_s: {
		name: 'Tria Guarotech S',
		bp: 6,
		tec_pot: 2.25,
		dmg_resist: -1,
	},
	tria_spiromel: {
		name: 'Tria Spiromel',
		bp: 6,
		pp: -3,
		mel_pot: 2.25,
	},
	tria_spiromel_s: {
		name: 'Tria Spiromel S',
		bp: 6,
		pp: -3,
		mel_pot: 2.25,
	},
	tria_spirora: {
		name: 'Tria Spirora',
		bp: 6,
		pp: -3,
		rng_pot: 2.25,
	},
	tria_spirora_s: {
		name: 'Tria Spirora S',
		bp: 6,
		pp: -3,
		rng_pot: 2.25,
	},
	tria_spirotech: {
		name: 'Tria Spirotech',
		bp: 6,
		pp: -3,
		tec_pot: 2.25,
	},
	tria_spirotech_s: {
		name: 'Tria Spirotech S',
		bp: 6,
		pp: -3,
		tec_pot: 2.25,
	},
	tria_staromel: {
		name: 'Tria Staromel',
		bp: 6,
		hp: -5,
		mel_pot: 2.25,
	},
	tria_staromel_s: {
		name: 'Tria Staromel S',
		bp: 6,
		hp: -5,
		mel_pot: 2.25,
	},
	tria_starora: {
		name: 'Tria Starora',
		bp: 6,
		hp: -5,
		rng_pot: 2.25,
	},
	tria_starora_s: {
		name: 'Tria Starora S',
		bp: 6,
		hp: -5,
		rng_pot: 2.25,
	},
	tria_starotech: {
		name: 'Tria Starotech',
		bp: 6,
		hp: -5,
		tec_pot: 2.25,
	},
	tria_starotech_s: {
		name: 'Tria Starotech S',
		bp: 6,
		hp: -5,
		tec_pot: 2.25,
	},
	triplble: {
		name: 'Triplble',
		bp: 8,
		mel_pot: 2,
		rng_pot: 2,
		tec_pot: 2,
	},
	vardi_soul_i: {
		name: 'Vardi Soul I',
		bp: 7,
		hp: 25,
		mel_pot: 1.25,
		rng_pot: 1.25,
		tec_pot: 1.25,
	},
	vardi_soul_i_s: {
		name: 'Vardi Soul I S',
		bp: 7,
		hp: 25,
		mel_pot: 1.25,
		rng_pot: 1.25,
		tec_pot: 1.25,
	},
	vardi_soul_ii: {
		name: 'Vardi Soul II',
		bp: 8,
		hp: 25,
		mel_pot: 1.75,
		rng_pot: 1.75,
		tec_pot: 1.75,
	},
	vardi_soul_ii_s: {
		name: 'Vardi Soul II S',
		bp: 8,
		hp: 25,
		mel_pot: 1.75,
		rng_pot: 1.75,
		tec_pot: 1.75,
	},
	vardi_soul_iii: {
		name: 'Vardi Soul III',
		bp: 10,
		hp: 25,
		mel_pot: 2.25,
		rng_pot: 2.25,
		tec_pot: 2.25,
	},
	vardi_soul_iii_s: {
		name: 'Vardi Soul III S',
		bp: 10,
		hp: 25,
		mel_pot: 2.25,
		rng_pot: 2.25,
		tec_pot: 2.25,
	},
	vardi_soul_iv: {
		name: 'Vardi Soul IV',
		bp: '?',
		hp: 25,
		mel_pot: 2.75,
		rng_pot: 2.75,
		tec_pot: 2.75,
	},
	vardi_soul_v: {
		name: 'Vardi Soul V',
		bp: '?',
		hp: 25,
		mel_pot: 3.75,
		rng_pot: 3.75,
		tec_pot: 3.75,
	},
	wind_exploit_i: {
		name: 'Wind Exploit I',
		bp: 6,
		wind_pot: 2.5,
	},
};
